export default "<ion-app *ngIf=\"isMobile\">\r\n  <ion-router-outlet></ion-router-outlet>\r\n</ion-app>\r\n";